var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPedestal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 433 728.1",
    style: {
      enableBackground: "new 0 0 433 728.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#303030;}\n\t.st1{fill:#D3D3D3;}\n\t.st2{fill:#C6C5C1;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:#89877C;}\n\t.st5{fill:#EDECE6;}\n\t.st6{opacity:0.43;fill:#C6C5C1;enable-background:new    ;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M363.5,6.8C324.2,2.4,272,0,216.5,0C161,0,108.8,2.4,69.5,6.8C11.4,13.3,0,21.3,0,33.1v52.3l4.5,3 c1,0.7,4.4,2.7,12.2,5.3v18.9l4.5,3c1.3,0.9,8.2,5,27.4,9.4v614.1l4.5,3c1.8,1.2,9.4,5.4,30.7,9.6c9.6,1.9,21,3.6,33.8,4.9 c8,0.8,16.3,1.5,24.5,2.1c9.9,0.7,21.1,1.2,33.2,1.6c7,0.2,14.8,0.4,24.4,0.5c5.3,0.1,10.9,0.1,16.6,0.1c5.7,0,11.3,0,16.6-0.1 c9.6-0.1,17.4-0.3,24.4-0.5c12.2-0.4,23.4-0.9,33.2-1.6c8.3-0.5,16.6-1.2,24.6-2.1c12.8-1.3,24.1-3,33.8-4.9 c21.4-4.1,29-8.4,30.8-9.6l4.5-3V125c19.2-4.4,26.1-8.5,27.4-9.4l4.5-3V93.7c7.8-2.6,11.2-4.6,12.1-5.3l4.6-3V33.1 C433,21.3,421.6,13.3,363.5,6.8z M422.9,80c0,0-4.1,2.7-16.7,6.3v21c0,0-7.1,4.7-32,9.7v616.9c0,0-6,4-27.1,8.1 c-8.4,1.7-19.2,3.3-32.9,4.8c-7.2,0.8-15.2,1.5-24.2,2.1c-9.8,0.7-20.8,1.2-32.9,1.6c-7.6,0.3-15.6,0.4-24.2,0.5 c-5.3,0.1-10.8,0.1-16.5,0.1s-11.2,0-16.5-0.1c-8.5-0.1-16.6-0.2-24.2-0.5c-12.1-0.4-23-0.9-32.9-1.6c-8.9-0.6-17-1.3-24.2-2.1 c-13.7-1.4-24.5-3.1-32.9-4.8c-21.1-4.1-27.1-8.1-27.1-8.1V116.8c-24.8-4.9-32-9.7-32-9.7v-21C14.2,82.7,10.1,80,10.1,80V33.1 c0-12.7,92.4-23,206.4-23s206.4,10.3,206.4,23V80z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M233,684.8v66c-5.3,0.1-10.8,0.1-16.5,0.1L233,684.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M229.4,127.8c-4.2,0-8.5,0-12.9,0s-8.7,0-12.8,0c-74.8-0.5-119.3-5.8-144.9-10.9c-24.8-4.9-32-9.7-32-9.7v-21 C14.2,82.7,10.1,80,10.1,80V33.1c0-12.7,92.4-23,206.4-23c-114,0-206.4,10.3-206.4,23V80c0,0,4.1,2.7,16.7,6.3v21 c0,0,7.1,4.7,32,9.7c25.6,5.1,70,10.4,144.9,10.9c4.2,0,8.4,0,12.8,0S225.2,127.8,229.4,127.8c2.7,0,5.3-0.1,7.8-0.1 c70.2-0.8,112.4-6,137.1-10.8c-24.7,4.9-66.9,10-137.1,10.8C234.6,127.7,232,127.7,229.4,127.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M143,161.7c0-2.8,0.7-5.5,2-7.9C143.7,156.2,142.9,158.9,143,161.7l0,587c9.8,0.7,20.8,1.2,32.9,1.6 c-12.1-0.4-23-0.9-32.9-1.6L143,161.7L143,161.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M85.9,741.8V152.9c0-5.7,2.9-10.7,7.2-13.7c-4.4,3-7.3,8-7.3,13.7L85.9,741.8c8.3,1.7,19.1,3.3,32.9,4.8 C105,745.2,94.2,743.5,85.9,741.8L85.9,741.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M216.5,10.1c114,0,206.4,10.3,206.4,23C422.9,20.4,330.5,10.1,216.5,10.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M10.1,33.1c0,12.7,92.4,22.9,206.4,22.9c114,0,206.3-10.3,206.4-22.9c0-12.7-92.4-23-206.4-23 C102.5,10.1,10.1,20.4,10.1,33.1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M422.9,80c0,0-4.1,2.7-16.7,6.3C418.8,82.7,422.9,80,422.9,80V33.1V80z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M216.5,56c-114,0-206.4-10.3-206.4-22.9V80c0,0,4.1,2.7,16.7,6.3c23.6,6.6,77.2,16.2,189.7,16.2 c112.5,0,166.1-9.6,189.7-16.2c12.6-3.5,16.7-6.3,16.7-6.3V33.1C422.8,45.8,330.4,56,216.5,56z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M406.2,107.2c0,0-7.1,4.7-32,9.7C399,111.9,406.2,107.2,406.2,107.2v-21V107.2z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M406.2,107.2v-21c-23.6,6.6-77.1,16.2-189.7,16.2c-112.5,0-166-9.6-189.7-16.2v21c0,0,7.1,4.7,32,9.7 c25.6,5.1,70,10.4,144.9,10.9c4.2,0,8.5,0,12.8,0s8.7,0,12.9,0c2.7,0,5.3-0.1,7.8-0.1c70.2-0.8,112.4-6,137.1-10.8 C399,111.9,406.2,107.2,406.2,107.2z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M58.8,116.8v616.9c0,0,6,4,27.1,8.1c-21.1-4.1-27.1-8.1-27.1-8.1V116.8z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M229.4,127.8c-4.2,0-8.5,0-12.9,0s-8.7,0-12.8,0c-74.8-0.5-119.3-5.8-144.9-10.9v616.9c0,0,6,4,27.1,8.1V152.9 c0-5.7,2.9-10.7,7.3-13.7c2.6-1.8,5.8-2.8,9.2-2.8c9.1,0,16.4,7.4,16.4,16.5v593.7c7.2,0.8,15.3,1.5,24.2,2.1v-587 c0-2.8,0.7-5.5,2-7.9c2.8-5.1,8.2-8.6,14.5-8.6c9.1,0,16.4,7.4,16.4,16.5v588.6c7.6,0.3,15.6,0.4,24.2,0.5V166.2 c0-9.1,7.4-16.5,16.4-16.5c9.1,0,16.4,7.4,16.4,16.5v518.6l24.2-97.2V161.7c0-9.1,7.4-16.5,16.4-16.5c9.1,0,16.4,7.4,16.4,16.5 v293.6l24.2-97.2V152.9c0-9.1,7.4-16.5,16.4-16.5c9.1,0,16.4,7.4,16.4,16.5v73l27.1-109c-24.7,4.9-66.9,10-137.1,10.8 C234.7,127.7,232.1,127.7,229.4,127.8L229.4,127.8z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M233,166.2v518.6l-16.5,66.1c-5.7,0-11.2,0-16.5-0.1V166.2c0-9.1,7.4-16.5,16.5-16.5S233,157.1,233,166.2z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M159.4,145.2c-6.2,0-11.7,3.5-14.4,8.6c-1.3,2.3-2,5-2,7.9v587c9.8,0.7,20.8,1.2,32.9,1.6V161.7 C175.9,152.6,168.5,145.2,159.4,145.2L159.4,145.2z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M175.9,161.7c0-9.1-7.4-16.5-16.4-16.5c-6.2,0-11.7,3.5-14.5,8.6c2.8-5.1,8.2-8.6,14.4-8.6 C168.5,145.2,175.8,152.6,175.9,161.7l0,588.6L175.9,161.7L175.9,161.7z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M347.1,152.9c0-9.1-7.4-16.5-16.4-16.5c-9.1,0-16.4,7.4-16.4,16.5v205.2l32.9-132.2V152.9z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M290,161.7c0-9.1-7.4-16.5-16.4-16.5c-9.1,0-16.4,7.4-16.4,16.5v425.8L290,455.3V161.7z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M85.9,152.9v588.9c8.4,1.7,19.2,3.3,32.9,4.8V152.9c0-9.1-7.4-16.5-16.4-16.5c-3.4,0-6.6,1-9.2,2.8 C88.8,142.2,85.9,147.2,85.9,152.9L85.9,152.9z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M118.8,152.9v593.7V152.9c0-9.1-7.4-16.5-16.4-16.5c-3.4,0-6.6,1-9.2,2.8c2.6-1.8,5.8-2.8,9.2-2.8 C111.4,136.4,118.8,143.8,118.8,152.9L118.8,152.9z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M257.1,750.3V587.5l-24.2,97.2v66C241.5,750.7,249.5,750.5,257.1,750.3z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M257.1,587.5v162.7c-7.6,0.3-15.6,0.4-24.2,0.5v-66L257.1,587.5z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M347.1,741.8c21.1-4.1,27.1-8.1,27.1-8.1V116.8l-27.1,109V741.8z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M347.1,741.8c21.1-4.1,27.1-8.1,27.1-8.1V116.8l-27.1,109V741.8z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M314.2,746.6V358.1L290,455.3v293.3C299,748.1,307,747.4,314.2,746.6z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M314.2,746.6V358.1L290,455.3v293.3C299,748.1,307,747.4,314.2,746.6z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M347.1,741.8v-516l-32.9,132.2v388.5C327.9,745.2,338.7,743.5,347.1,741.8z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M347.1,741.8v-516l-32.9,132.2v388.5C327.9,745.2,338.7,743.5,347.1,741.8z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M290,748.7V455.3l-32.9,132.2v162.7C269.3,749.9,280.2,749.3,290,748.7z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M290,748.7V455.3l-32.9,132.2v162.7C269.3,749.9,280.2,749.3,290,748.7z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M233,684.8v66c-5.3,0.1-10.8,0.1-16.5,0.1L233,684.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPedestal);
export default __webpack_public_path__ + "static/media/pedestal.87034b9d4917afdff8354e2d06a570ff.svg";
export { ForwardRef as ReactComponent };